// gd-scroll-reveal.js — IntersectionObserver fade+translate.
// Matches Bolt ui/ScrollReveal.tsx (threshold 0.15, one-shot).
// Respects prefers-reduced-motion.

(function () {
  'use strict';

  const mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  const prefersReduced = mq && mq.matches;

  function revealAll() {
    const els = document.querySelectorAll('[data-gd-reveal]:not(.is-gd-revealed)');
    els.forEach((el) => el.classList.add('is-gd-revealed'));
  }

  if (prefersReduced || typeof IntersectionObserver === 'undefined') {
    // Show everything immediately; no motion.
    revealAll();
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-gd-revealed');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.15 }
  );

  function observeAll(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-gd-reveal]:not(.is-gd-revealed)').forEach((el) => {
      observer.observe(el);
    });
  }

  // Initial pass.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observeAll());
  } else {
    observeAll();
  }

  // Re-observe on section renders (theme editor).
  document.addEventListener('shopify:section:load', (e) => observeAll(e.target));

  // Expose for manual re-scan.
  window.gdScrollReveal = { refresh: observeAll };
})();
